'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getIndexesForPage = function (itemsPerPage) { return ({
    start: 0,
    stop: itemsPerPage
}); };
var serverSideListStrategy = {
    getIndexesForPage: getIndexesForPage
};

exports.default = serverSideListStrategy;
exports.getIndexesForPage = getIndexesForPage;
//# sourceMappingURL=serverSideListStrategy.js.map
